"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePickerArea = void 0;
var _react = _interopRequireDefault(require("react"));
var _dates = require("../../../../utilities/dates");
var _TimePicker = require("../../TimePicker");
var _RangeDateTimePicker = _interopRequireDefault(require("../RangeDateTimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TimePickerArea = function TimePickerArea(props) {
  var dateTime = props.dateTime,
    minTime = props.minTime,
    maxTime = props.maxTime,
    minutesStep = props.minutesStep,
    title = props.title,
    onChange = props.onChange;
  var styles = (0, _RangeDateTimePicker.default)();
  var handleTimeChange = function handleTimeChange(hour, minute) {
    var newCurrentDateTime = new Date(dateTime);
    newCurrentDateTime.setHours(hour, minute, 0, 0);
    onChange(newCurrentDateTime);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-RangeDateTimePicker__inner-title'],
      children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: (0, _dates.formatDate)(dateTime, '{day}.{month}.{year}')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePicker.TimePicker, {
      defaultTime: dateTime,
      minHour: minTime === null || minTime === void 0 ? void 0 : minTime.hour,
      minMinute: minTime === null || minTime === void 0 ? void 0 : minTime.minute,
      maxHour: maxTime === null || maxTime === void 0 ? void 0 : maxTime.hour,
      maxMinute: maxTime === null || maxTime === void 0 ? void 0 : maxTime.minute,
      minutesStep: minutesStep,
      onChange: handleTimeChange
    })]
  });
};
exports.TimePickerArea = TimePickerArea;